import { produce } from "immer";
import { AuthenticationActions } from "../../../authentication/authentication.store";
import { IAppProperties, IAppProperty } from "./app-properties.model";
import { IPayloadAction } from "../../../../shared/shared.interfaces";

export const AppPropertiesActions = {
  types: {
    GET_APP_PROPERTIES_SUCCESS: "GET_APP_PROPERTIES_SUCCESS",
    GET_APP_PROPERTIES_LAST_VERSION_SUCCESS: " GET_APP_PROPERTIES_LAST_VERSION_SUCCESS",
  },
  creators: {
    getAppPropertiesSuccess: (appProperties: IAppProperties) => ({
      type: AppPropertiesActions.types.GET_APP_PROPERTIES_SUCCESS,
      payload: {
        appProperties,
      },
    }),
    getAppPropertiesLastVersionSuccess: (appProperties: IAppProperties) => ({
      type: AppPropertiesActions.types.GET_APP_PROPERTIES_LAST_VERSION_SUCCESS,
      payload: {
        appProperties,
      },
    }),
  },
};
export interface IAppPropertiesReducerInterface {
  appProperties: IAppProperties;
  lastVersion: IAppProperties;
}

const initialState: IAppPropertiesReducerInterface = {
  appProperties: {} as IAppProperties,
  lastVersion: {} as IAppProperties,
};

export const appPropertiesReducer = produce((draft: IAppPropertiesReducerInterface, action: IPayloadAction<any>) => {
  switch (action.type) {
    case AppPropertiesActions.types.GET_APP_PROPERTIES_SUCCESS:
      draft.appProperties = action.payload.appProperties;
      draft.appProperties.properties = action.payload.appProperties.properties.sort(
        (a: IAppProperty, b: IAppProperty) => (a.fieldName ? a.fieldName.localeCompare(b.fieldName) : -1),
      );
      return;
    case AppPropertiesActions.types.GET_APP_PROPERTIES_LAST_VERSION_SUCCESS:
      draft.lastVersion = action.payload.appProperties;
      draft.lastVersion.properties = action.payload.appProperties.properties.sort((a: IAppProperty, b: IAppProperty) =>
        a.fieldName ? a.fieldName.localeCompare(b.fieldName) : -1,
      );
      return;
    case AuthenticationActions.types.LOGOUT:
      return initialState;
    default:
      return draft;
  }
}, initialState);
